import React, { useEffect, useRef, useState } from "react";
import DownloadExcel from "../../../Extra/DownloadExcel";
import axios from "axios";

const Head = ["DATE", "MONTHLY", "YEARLY"];
const Head2 = [
  "UNLG",
  "INWARD",
  "T/O",
  "INWARD (O. DVN)",
  "%",
  "UNLG",
  "INWARD",
  "T/O",
  "INWARD (O. DVN)",
  "%",
  "UNLG",
  "INWARD",
  "T/O",
  "INWARD (O. DVN)",
  "%",
];

const IREPercentage = ({ date, selectedHead }) => {
  const urlCrisPrefix = process.env.REACT_APP_URL_PREFIX_CRIS;
  const tableRef = useRef();

  const [Data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const fetchedData = async () => {
    setLoading(true);
    setError(false);
    try {
      const response = await axios.get(
        `${urlCrisPrefix}get_wc420_data?date=${date}`,
      );

      if (response.data.status === "ok") {
        setData(response.data.data || {});
      } else {
        setData({});
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchedData();
  }, [date]);

  return (
    <div>
      <div
        className="table-responsive pt-0 fw-bold"
        style={{ fontSize: "12px", maxHeight: "750px" }}
      >
        <table
          className="table table-hover table-striped glassTable"
          ref={tableRef}
        >
          <thead className="sticky-top table-dark">
            <tr>
              <th colSpan={17}>IRE Percentage</th>
            </tr>
            <tr className="align-middle fw-bold">
              <th rowSpan={2}>SR NO</th>
              <th rowSpan={2}>TYPE</th>
              {Head.map((head, i) => (
                <th key={i} colSpan={5}>
                  {head}
                </th>
              ))}
            </tr>

            <tr>
              {Head2.map((col, i) => (
                <th key={i}>{col} </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Data?.current_date_data?.map((o, i) => {
              const month = Data?.current_month_data?.[i] || {};
              const fy = Data?.current_fy_data_till_date?.[i] || {};

              return (
                <tr key={i}>
                  <td>{i + 1}</td>

                  <td className=" border-end">{o?.rtype || "-"}</td>
                  <td>{o?.unloading || 0}</td>
                  <td>{o?.inward || 0}</td>
                  <td>{o?.taken_over || 0}</td>
                  <td>{o?.inward_other_div || 0}</td>
                  <td className=" border-end">{o?.percentage || 0}</td>

                  <td>{month?.unloading || 0}</td>
                  <td>{month?.inward || 0}</td>
                  <td>{month?.taken_over || 0}</td>
                  <td>{month?.inward_other_div || 0}</td>
                  <td className=" border-end">{month?.percentage || 0}</td>

                  <td>{fy?.unloading || 0}</td>
                  <td>{fy?.inward || 0}</td>
                  <td>{fy?.taken_over || 0}</td>
                  <td>{fy?.inward_other_div || 0}</td>
                  <td>{fy?.percentage || 0}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="m-1">
        <DownloadExcel
          tableRef={tableRef}
          fileName={`IRE Percentage ${date}`}
        />
      </div>
    </div>
  );
};

export default IREPercentage;
